import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Button, Grid } from "@mui/material";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Label,
} from "recharts";
import { useHistory } from "react-router-dom";
import ROUTES from "../../../AppRouter/routes";
import PieChartIcon from "@mui/icons-material/PieChart";
import BarChartIcon from "@mui/icons-material/BarChart";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { useWebServer } from "../../../../providers";
import { loadMonthlyData } from "../../../../actions";

const ButtonStyle = {
    padding: "3px 3px",
    margin: "0 5px",
    flex: "1",
    fontSize: "10px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
};

const formatMonth = (month) => {
    const date = new Date(month + "-02");
    return date.toLocaleString("en-us", { month: "long" });
};

const DataCopy = ({ loadMonthlyData, data }) => {
    const { downloadMonthlyImaging } = useWebServer();
    const history = useHistory();

    const graphData = useMemo(() => {
        if (data.length === 0) return [];

        let sortedData = data.sort((a, b) => new Date(a.date) - new Date(b.date));
        const last4Months = sortedData.slice(-4);
        return last4Months.map((monthData) => ({
            name: formatMonth(monthData.date),
            total: monthData.count,
        }));
    }, [data]);


    useEffect(() => {
        loadMonthlyData(downloadMonthlyImaging);
        //eslint-disable-next-line
    }, []);

    const lines = useMemo(() => [
        <Line
            key={0}
            type="monotone"
            dataKey="total"
            stroke="blue"
            activeDot={{ r: 8 }}
        />,
    ], []);

    const handleButtonClick = (buttonClicked) => {
        history.push(`${ROUTES.reports}?button=${buttonClicked}`);
    };

    return (
        <div style={{ maxWidth: "95%" }}>
            <div
                style={{ textAlign: "center", color: "#3f51b5", fontFamily: "Roboto" }}
            >
                <h2>TRAYS IMAGED PER MONTH</h2>
            </div>
            <div
                style={{
                    marginTop: "20px",
                    height: "350px",
                    width: "100%",
                    fontSize: "11px",
                }}
            >
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        width={500}
                        height={300}
                        data={graphData}
                        margin={{
                            top: 5,
                            right: 5,
                            left: 5,
                            bottom: 20,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name">
                            <Label
                                value="MONTH"
                                offset={0}
                                position="insideBottom"
                                style={{ fontSize: "12px", fontWeight: "bold" }}
                            />
                        </XAxis>
                        <YAxis>
                            <Label
                                value="COUNT"
                                angle={-90}
                                position="insideLeft"
                                style={{
                                    textAnchor: "middle",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                }}
                            />
                        </YAxis>
                        <Tooltip />
                        {lines}
                    </LineChart>
                </ResponsiveContainer>
            </div>
            {/* Reports section */}
            <div
                style={{
                    textAlign: "center",
                    justifyContent: "center",
                    marginTop: "20px",
                    color: "#3f51b5",
                    fontFamily: "Roboto",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        margin: "10px",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <div
                        style={{ marginBottom: "5px", fontWeight: "500", fontSize: "15px" }}
                    >
                        REPORTS
                    </div>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            height: "80px",
                            overflowWrap: "anywhere",
                            flexDirection: "row",
                            maxWidth: "100%",
                        }}
                    >
                        <Button
                            style={ButtonStyle}
                            variant={"contained"}
                            color={"primary"}
                            onClick={() => handleButtonClick("Raw-Data")}
                        >
                            RAW DATA
                        </Button>
                        <Button
                            style={ButtonStyle}
                            variant={"contained"}
                            color={"primary"}
                            onClick={() =>
                                handleButtonClick("Species-Summary-Among-Collections")
                            }
                        >
                            <div>SPECIES SUMMARY</div>
                            <div> AMONG COLLECTION </div>
                            <div>SITES</div>
                        </Button>
                        <Button
                            style={ButtonStyle}
                            variant={"contained"}
                            color={"primary"}
                            onClick={() => handleButtonClick("Weekly-Species-report")}
                        >
                            WEEKLY SPECIES REPORT
                        </Button>
                    </div>
                </div>
                <div
                    style={{
                        display: "flex",
                        margin: "8px",
                        flexDirection: "column",
                        alignItems: "center",
                        color: "#3f51b5",
                        fontFamily: "Roboto",
                    }}
                >
                    <div
                        style={{ marginBottom: "5px", fontWeight: "500", fontSize: "15px" }}
                    >
                        GRAPHS
                    </div>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            height: "80px",
                            overflowWrap: "anywhere",
                            flexDirection: "row",
                            maxWidth: "100%",
                        }}
                    >
                        <Button
                            style={ButtonStyle}
                            variant={"contained"}
                            color={"primary"}
                            onClick={() => handleButtonClick("Pie-chart")}
                        >
                            <div style={{ marginTop: "10px" }}>SPECIES</div>
                            <div> SUMMARY</div>{" "}
                            <div style={{ marginTop: "8px" }}  >
                                <PieChartIcon style={{ fontSize: "20px" }} />
                            </div>
                        </Button>
                        <Button
                            style={ButtonStyle}
                            variant={"contained"}
                            color={"primary"}
                            onClick={() => handleButtonClick("Bar-chart")}
                        >
                            SPECIES SUMMARY<br />AMONG COLLECTION<br />SITES{" "}
                            <BarChartIcon style={{ fontSize: "15px", border: "1px solid white" }} />
                        </Button>
                        <Button
                            style={ButtonStyle}
                            variant={"contained"}
                            color={"primary"}
                            onClick={() => handleButtonClick("LineGraph-Chart")}
                        >
                            SPECIES ABUNDANCE BY MONTH
                            <ShowChartIcon style={{ fontSize: "15px", border: "1px solid white", marginTop: "8px", }} />

                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const mapStateToProps = (state) => {
    return {
        data: state?.report?.monthlyData?.data,
    };
};
export default connect(mapStateToProps, { loadMonthlyData, })(DataCopy);
